'use strict';

var Sugar = require('sugar-core');

require('../date/build/buildNumberUnitMethodsCall');

module.exports = Sugar.Number.monthBefore;


//////////////////
// WEBPACK FOOTER
// ./~/sugar-date/number/monthBefore.js
// module id = 366
// module chunks = 1